module.exports = __webpack_public_path__ + "img/seventy-percent.df921547.png";